module.exports = __webpack_public_path__ + "static/media/291902.9ee4ab73.png";